interface NoteLike {
  type?: unknown
  category?: unknown
  recordKind?: unknown
  title?: unknown
  content?: unknown
  questionImage?: unknown
  questionOptions?: unknown
}

const WHITESPACE = /\s+/g

function normalizeText(value: unknown) {
  return typeof value === 'string' ? value.trim().replace(WHITESPACE, ' ') : ''
}

/** 空富文本（'<p></p>'、纯空白标签）不算有文字内容；纯图错题卡的正文恒为空段落 */
function hasVisibleText(value: unknown) {
  if (typeof value !== 'string') return false
  return value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(WHITESPACE, ' ').trim().length > 0
}

function stableOptions(value: unknown) {
  if (!value || typeof value !== 'object') return ''
  const options = value as Record<string, unknown>
  return ['A', 'B', 'C', 'D'].map(key => `${key}:${normalizeText(options[key])}`).join('|')
}

/**
 * Semantic identity for an exact duplicate card. Metadata that legitimately
 * changes between devices (review state, source, tags, timestamps) is excluded.
 * Image-only questions include their image, so unrelated screenshots are never
 * collapsed merely because both have an empty title/content.
 */
export function noteSemanticKey(note: NoteLike | null | undefined) {
  if (!note || note.type === 'mistake_notebook' || note.category === '__mistake_notebook__') return ''
  const title = normalizeText(note.title)
  const rawContent = typeof note.content === 'string' ? note.content : ''
  const content = normalizeText(rawContent)
  const image = normalizeText(note.questionImage)
  const options = stableOptions(note.questionOptions)
  // 内容判定必须看渲染后的可见文字：'<p></p>' 是空段落而非文字，
  // 否则纯图错题卡（标题空、正文恒为空段落）会共享同一指纹被错误合并
  const hasText = Boolean(title) || hasVisibleText(rawContent)
  if (!hasText && !image) return ''
  const questionIdentity = hasText ? '' : `${image}|${options}`
  return JSON.stringify([
    normalizeText(note.category),
    normalizeText(note.recordKind),
    title,
    content,
    questionIdentity,
  ])
}

export function notesAreSemanticDuplicates(left: NoteLike | null | undefined, right: NoteLike | null | undefined) {
  const leftKey = noteSemanticKey(left)
  return Boolean(leftKey && leftKey === noteSemanticKey(right))
}
